import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, VariantFilterOptionsModel, VariantFilterValue, FilterType } from "../models/product";
import UniqueVariantFilter from "./UniqueVariantFilter";
import ImageVariantFilter from "./ImageVariantFilter";

@Component({
    components: {
        UniqueVariantFilter,
        ImageVariantFilter
    }
})
export default class DoubleVariantFilter extends Vue {
    protected primaryFilterId: string = "";
    protected primaryFilterName: string = "";
    protected primaryFilterValues: VariantFilterValue[] = [];
    protected primaryFilterValueUnit: string = "";
    protected primaryFilterValue: string = "";
    protected secondaryFilterId: string = "";
    protected secondaryFilterName: string = "";
    protected secondaryFilterValues: VariantFilterValue[] = [];
    protected secondaryFilterValueUnit: string = "";
    protected secondaryFilterValue: string = "";

    protected thisSelectedFilterValue: string = "";
    protected variantsWithFilterValue: Variant[] = [];


    @Prop()
    protected filters!: VariantFilterOptionsModel[];
    protected filter!: VariantFilterOptionsModel;

    protected mounted() {
        const primaryFilter = this.filters[0];
        const secondaryFilter = this.filters[1];
        this.primaryFilterId = primaryFilter.filterId;
        this.primaryFilterName = primaryFilter.filterName;
        this.primaryFilterValues = primaryFilter.filterValues;
        this.primaryFilterValueUnit = primaryFilter.filterValueUnit;
        this.secondaryFilterId = secondaryFilter.filterId;
        this.secondaryFilterName = secondaryFilter.filterName;
        this.secondaryFilterValueUnit = secondaryFilter.filterValueUnit;
        this.setInitialSelectedFilterValues();

        this.showVaraintsIfNeeded();
    }
    @Watch("selectedVariantId")
    protected onSelectedVariantIdChange() {
        const selectedFilterValue = this.primaryFilterValues.find(x => x.variantId === this.selectedVariantId);
        if (selectedFilterValue) {
            this.primaryFilterValue = selectedFilterValue.value;
            this.onPrimaryFilterChange();
        }
    }

    @Watch("primaryFilterValue")
    protected onPrimaryFilterChange() {
        this.setPrimaryFilter(this.primaryFilterValue);

        if (this.secondaryFilterValues && this.secondaryFilterValues.length) {
            this.selectedVariantId = this.secondaryFilterValues[0].variantId;
        }
        this.showVaraintsIfNeeded();
    }

    @Watch("secondaryFilterValue")
    protected onSecondayFilterValueChange() {
        const selectedFilterValue = this.secondaryFilterValues.find(x => x.value === this.secondaryFilterValue);
        if (selectedFilterValue) {
            this.selectedVariantId = selectedFilterValue.variantId;
        }
        this.onSecondaryFilterChange();
    }

    protected onSecondaryFilterChange() {
        this.showVaraintsIfNeeded();
    }

    protected isImageFilter(filterType: number) {
        return filterType === FilterType.Image;
    }

    private showVaraintsIfNeeded() {
        const curFilterValue = this.getAttributeValue(this.selectedVariant, this.secondaryFilterId);

        let filteredVariants = this.variants.filter(v => this.hasAttribute(v, this.secondaryFilterId, curFilterValue));

        const curPrimaryFilterValue = this.getAttributeValue(this.selectedVariant, this.primaryFilterId);
        filteredVariants = filteredVariants.filter(v => this.hasAttribute(v, this.primaryFilterId, curPrimaryFilterValue));

        if (filteredVariants.length === 1) {
           this.variantsWithFilterValue = [];   // to hide variant selector dropdown
           productStore.dispatchVariant(filteredVariants[0]);
        } else {
           this.variantsWithFilterValue = filteredVariants;
        }
    }

    private setInitialSelectedFilterValues() {
        this.primaryFilterValue = this.getAttributeValue(this.selectedVariant, this.primaryFilterId);
        this.setPrimaryFilter(this.primaryFilterValue);
        this.selectedVariantId = this.selectedVariant.variantId;
    }

    private get selectedVariant() {
        return productStore.variant;
    }

    get variants(): Variant[] {
        return productStore.variants;
    }

    get selectedFilterValue(): string {
        return this.thisSelectedFilterValue;
    }

    get selectedVariantId(): string {
        return productStore.variant.variantId;
    }

    set selectedVariantId(value: string) {
        const variant = this.variants.find(x => x.variantId.toString() === value.toString());

        if (variant) {
            productStore.dispatchVariant(variant);
        }
    }

    private setPrimaryFilter(filterValue: string) {
        const variants = this.variants.filter(v => this.hasAttribute(v, this.primaryFilterId, filterValue));
        const secondaryFilterValues: VariantFilterValue[] = variants.map(x => {
            return {
                    variantId: x.variantId,
                    value: this.getAttributeValue(x, this.secondaryFilterId),
                    imageResourceUrl: this.getImageResourceUrl(x.variantId)
                };
            }
        );

        // Make List Distinct
        const distinctSecondaryFilterValues = [];
        const tempList = [];
        for (const item of secondaryFilterValues) {
            if (tempList.indexOf(item.value) === -1) {
                tempList.push(item.value);
                distinctSecondaryFilterValues.push(item);
            }
        }

        this.secondaryFilterValues = distinctSecondaryFilterValues;
    }

    private hasAttribute(variant: Variant, id: string, value: string): boolean {
        for (const attribute of variant.variantAttributes) {
            if (attribute.attributeId === id) {
                if (attribute.attributeValue === value) {
                    return true;
                }
            }
        }

        return false;
    }

    private getAttributeValue(variant: Variant, filterId: string): string {
        for (const attribute of variant.variantAttributes) {
            if (attribute.attributeId === filterId) {
                return attribute.attributeValue;
            }
        }

        return "";
    }

    private getImageResourceUrl(variantId: string) {
        const filterValue = this.filters[1].filterValues.find(x => x.variantId === variantId);
        return filterValue ? filterValue.imageResourceUrl : "";
    }
}
